import smoothscroll from 'smoothscroll-polyfill';

export default function () {
// kick off the scroll polyfill!
  smoothscroll.polyfill();
}
